import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Button, Container, Nav, Navbar, NavDropdown, Offcanvas} from "react-bootstrap";
import logo from "../logo/ab_white_style.svg";
import logoFullW from "../logo/altrabits_style_white.svg";
import {IconDropdown} from "./_components";
import {useAuth, useDarkMode} from "../context";
import {useApp, useInBrowserTab, useOnlineStatus, useWindowSize} from "../hooks";
import {useBasketCount} from "./shop/useShop";
import {usePublicTagList} from "../hooks/usePublicEndpoint";
import {AppStatus} from "./Footer";
import {OurClearAlert} from "./_components";

export function HeaderBootstrap() {

    const isInBrowserTab = useInBrowserTab()
    // const isInBrowserTab = false // Simulate Standalone
    const {width} = useWindowSize()
    const breakpoints = {sm: 576, md: 768, lg: 992}

    if (isInBrowserTab) {
        return width < breakpoints.sm ? <NavbarForBrowserTab/> : <NavbarForFullScreen/>
    } else {
        return width < breakpoints.md ? <NavbarForStandalone/> : <NavbarForFullScreen/>
    }
}

function NavbarForStandalone() {
    const navigate = useNavigate()
    const {loggedIn, userId, user} = useAuth()
    const {darkMode, toggleDarkMode} = useDarkMode()
    const location = useLocation()
    const {count} = useBasketCount()

    const {name, version, isDebug} = useApp()
    const online = useOnlineStatus()

    // Manage Offcanvas
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showUser, setShowUser] = useState(false)
    const handleCloseUser = () => setShowUser(false);
    const handleShowUser = () => setShowUser(true);

    function handleOnSelect(e) {
        if (e !== "navbutton") {
            navigate(e)
            handleClose()
        }
    }

    function handleToggle() {
        toggleDarkMode()
        handleClose()
    }

    return <Navbar expand={true} fixed="bottom" bg="primary" variant="dark" className="p-1">
        <Container fluid>

            <Nav className="d-flex align-items-center justify-content-between w-100" onSelect={e => navigate(e)} activeKey={location.pathname}>

                {loggedIn && <Nav.Item>
                    <Nav.Link onClick={handleShowUser}><i className="bi bi-person-check fs-3"
                                                          style={{transform: 'scale(1.2)', display: 'inline-block'}}/></Nav.Link>
                </Nav.Item>}
                {!loggedIn && <Nav.Item>
                    <Nav.Link eventKey="/account/login" className=""><i className="bi bi-person fs-3"
                                                                        style={{transform: 'scale(1.2)', display: 'inline-block'}}/></Nav.Link>
                </Nav.Item>}

                {/*<Nav.Item className="">*/}
                {/*    <Nav.Link eventKey={`/manage/${userId}/list`} className=""><FileGear size="fs-3"*/}
                {/*                                                                         style={{transform: 'scale(1.2)', display: 'inline-block'}}/></Nav.Link>*/}
                {/*</Nav.Item>*/}
                <Nav.Item className="">
                    <Nav.Link eventKey={`/device/${userId}`} className=""><i className="bi bi-gear fs-3"
                                                                                    style={{transform: 'scale(1.2)', display: 'inline-block'}}/></Nav.Link>
                </Nav.Item>

                <Nav.Item className="">
                    <Nav.Link eventKey="/" className="d-flex justify-content-center align-items-center rounded-circle"
                              style={{width: '50px', height: '50px', border: '2px solid currentColor'}}
                    >
                        <img src={logo} alt="AltraBits Logo" style={{transform: 'scale(0.7)'}}/>
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item className="">
                    <Nav.Link eventKey="/shop" className=""><i className="bi bi-bag fs-3"
                                                               style={{transform: 'scale(1.2)', display: 'inline-block'}}/></Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link onClick={handleShow} className=""><i className="bi bi-three-dots-vertical fs-3"
                                                                   style={{transform: 'scale(1.2)', display: 'inline-block'}}/></Nav.Link>
                </Nav.Item>

            </Nav>

            {/*Offcanvas for more options*/}
            <Offcanvas id="offcanvasNavbar-alone" aria-labelledby="offcanvasNavbarLabel-alone" show={show} onHide={handleClose} placement="bottom">
                <Offcanvas.Header closeButton className="bg-primary p-2">
                    <Offcanvas.Title>
                        <img src={logo} alt="AltraBits" className=""/>
                        {/*{(user?.first_name && user?.last_name) && <span className="">{user.first_name} {user.last_name}</span>}*/}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {/*<Nav activeKey={location.pathname} onSelect={handleOnSelect}>*/}

                    <div className="d-flex flex-column ms-1 w-100">

                        <Button variant="link"
                                className={`text-decoration-none text-body-emphasis text-start ${location.pathname.startsWith("/shop/cart") ? "fw-semibold" : ""}`}
                                onClick={() => handleOnSelect("/shop/cart")}><i className={`bi bi-cart${count > 0 ? '-check' : ''} me-1`}/>Cart</Button>

                        <Button variant="link" className="text-decoration-none text-body-emphasis text-start"
                                onClick={handleToggle}>{darkMode ? <i className="bi bi-sun me-1"/> : <i className="bi bi-moon me-1"/>}Theme</Button>

                        <Button variant="link"
                                className={`text-decoration-none text-body-emphasis text-start ${location.pathname.startsWith("/contact-us") ? "fw-semibold" : ""}`}
                                onClick={() => handleOnSelect("/contact-us")}><i className="bi bi-person-lines-fill me-1"/>Contact us</Button>

                        <Button variant="link"
                                className={`text-decoration-none text-body-emphasis text-start ${location.pathname.startsWith("/static/about") ? "fw-semibold" : ""}`}
                                onClick={() => handleOnSelect("/static/about")}><i className="bi bi-info-square me-1"/>About</Button>

                    </div>

                </Offcanvas.Body>

                <Container fluid className="d-flex justify-content-around align-items-center bg-body-secondary py-0">
                    <span style={{fontSize: ".85rem"}}><AppStatus name={name} debug={isDebug} version={version} online={online}/></span>
                    <span style={{fontSize: ".85rem"}}>© 2024 Copyright <a style={{textDecoration: "none"}} href="https://altrabits.com/">AltraBits.com</a></span>
                </Container>

            </Offcanvas>

            {/*Offcanvas for User options*/}
            <Offcanvas id="offcanvasNavbar-aloneuser" aria-labelledby="offcanvasNavbarLabel-aloneuser" show={showUser} onHide={handleCloseUser}
                       placement="bottom">
                <Offcanvas.Header closeButton className="bg-primary p-2">
                    <Offcanvas.Title>
                        {!loggedIn && <img src={logo} alt="AltraBits" className=""/>}
                        {(user?.first_name && user?.last_name) && <span className="text-white">{user.first_name} {user.last_name}</span>}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>

                    {/*<Nav activeKey={location.pathname} onSelect={handleOnSelectUser}>*/}

                    {loggedIn &&
                        <div className="d-flex flex-column align-items-start">
                            <AccountOptions handleClose={handleClose} setShowAccount={setShowUser} link={true}/>
                        </div>
                    }

                    {/*</Nav>*/}

                </Offcanvas.Body>

            </Offcanvas>

        </Container>
    </Navbar>
}


function NavbarForBrowserTab() {
    const navigate = useNavigate()
    const {loggedIn, userId, user} = useAuth()
    const {darkMode, toggleDarkMode} = useDarkMode()
    const location = useLocation()
    const {count} = useBasketCount()

    const [show, setShow] = useState(false);
    const [showTags, setShowTags] = useState(false)
    const [showAccount, setShowAccount] = useState(false)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setShowTags(false)
        setShowAccount(false)
    }

    const {value: tagList, loadingValue: tagLoading, errorValue: tagError, clearError: tagClearError} = usePublicTagList()
    const sortedTags = tagList.sort((a, b) => b.product_count - a.product_count).filter((item, index) => index < 5)

    function handleOnSelect(e) {
        if (e !== "navbutton") {
            navigate(e)
            handleClose()
        }
    }

    function handleToggle() {
        toggleDarkMode()
        handleClose()
    }


    return <>
        <OurClearAlert variant="danger" msg={tagError} onClear={tagClearError}/>

        <Navbar expand={true} sticky="top" bg="primary" variant="dark" className="p-1">
            <Container fluid>
                <Navbar.Brand href="/"><img src={logo} alt="AltraBits" className=""/></Navbar.Brand>
                <Nav className="me-auto" onSelect={e => navigate(e)}>
                    <Nav.Link eventKey="/shop" className="py-0">Shop</Nav.Link>
                    {loggedIn && <Nav.Link eventKey={`/device/${userId}`} className="py-0">Control</Nav.Link>}
                </Nav>

                <Nav className="" onSelect={e => navigate(e)}>
                    <div className="d-flex align-items-center">
                        <Nav.Item className="">
                            <Nav.Link eventKey="/shop/cart" className="py-0">{<i className={`bi bi-cart${count > 0 ? '-check' : ''} fs-4`}/>}</Nav.Link>
                        </Nav.Item>
                        {/*{loggedIn && <Nav.Item><UserDropdown/></Nav.Item>}*/}
                        {/*{!loggedIn && <Nav.Item>*/}
                        {/*    <Nav.Link eventKey="/account/login" className="py-0"> <i className="bi bi-person fs-4"/></Nav.Link>*/}
                        {/*</Nav.Item>}*/}
                        <Nav.Item>
                            <Nav.Link onClick={handleShow} className="py-0"><i className="bi bi-three-dots-vertical fs-4"/></Nav.Link>
                        </Nav.Item>
                    </div>
                </Nav>

                <Offcanvas id="offcanvasNavbar-md" aria-labelledby="offcanvasNavbarLabel-md" show={show} onHide={handleClose} placement="end">
                    <Offcanvas.Header closeButton className="bg-primary p-2">
                        <Offcanvas.Title>
                            {!loggedIn && <img src={logo} alt="AltraBits" className=""/>}
                            {(user?.first_name && user?.last_name) && <span className="text-white">{user.first_name} {user.last_name}</span>}
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav activeKey={location.pathname} onSelect={handleOnSelect}>

                            {/*Account: login & logout*/}
                            {loggedIn &&
                                <OffcanvasCustomLink2 title="Account" active={location.pathname.startsWith("/backend")} icon="bi-person-check"
                                                      onClick={() => setShowAccount(!showAccount)} showValue={showAccount}/>
                            }
                            {showAccount &&
                                <div className="d-flex flex-column align-items-start">
                                    <AccountOptions handleClose={handleClose} setShowAccount={setShowAccount}/>
                                </div>
                            }

                            {!loggedIn && <OffcanvasCustomLink2 title="Login" active={location.pathname.startsWith("/account")} icon="bi-person" onClick={() => {
                                navigate("/account/login")
                                handleClose()
                            }} showValue={null}/>
                            }

                            {/*Devices managment*/}
                            {/*{loggedIn &&*/}
                            {/*    <OffcanvasCustomLink2 title="Devices" active={location.pathname.startsWith("/manage")} icon={<i><FileGear/></i>} onClick={() => {*/}
                            {/*        navigate(`/manage/${userId}/list`)*/}
                            {/*        handleClose()*/}
                            {/*    }} showValue={null}/>*/}
                            {/*}*/}
                            {loggedIn &&
                                <OffcanvasCustomLink2 title="Control" active={location.pathname.startsWith("/device")} icon="bi-gear" onClick={() => {
                                    navigate(`/device/${userId}`)
                                    handleClose()
                                }} showValue={null}/>
                            }

                            {/*Shop tags*/}
                            <OffcanvasCustomLink2 title="Shop" active={location.pathname.startsWith("/shop")} icon="bi-bag" onClick={() => setShowTags(!showTags)}
                                                  showValue={showTags}/>
                            {showTags &&
                                <div className="d-flex flex-wrap gap-2 ms-3">
                                    <Button variant="outline-primary" onClick={() => handleOnSelect("/shop")}>All Products</Button>
                                    {tagLoading ?
                                        <div>Loading...</div>
                                        :
                                        sortedTags.map(tag =>
                                            <Button key={tag.id} variant="outline-primary"
                                                    onClick={() => handleOnSelect(`/shop/products?tags=${tag.id}`)}>{tag.name}</Button>)}
                                </div>
                            }

                        </Nav>

                    </Offcanvas.Body>

                    <div className="bg-body-secondary p-2 ">
                        <Nav className="" onSelect={handleToggle}>
                            <Nav.Link eventKey={location.pathname}>{darkMode ? <i className="bi bi-sun me-1"/> : <i className="bi bi-moon me-1"/>}Theme</Nav.Link>
                        </Nav>
                        <Nav onSelect={handleOnSelect}>
                            {loggedIn && <Nav.Link eventKey="/account/logout"><i className="bi bi-person-fill-slash me-1"/>Logout</Nav.Link>}
                        </Nav>
                    </div>
                </Offcanvas>
            </Container>
        </Navbar>
    </>
}


function OffcanvasCustomLink2({title, active, icon, onClick, showValue}) {
    return <Button variant="link" className="text-decoration-none text-body-emphasis px-0 d-flex justify-content-between align-items-center w-100 my-1"
                   onClick={onClick}>
        <span className={`d-flex align-items-center ${active && "fw-semibold"}`}>{typeof icon === "string" ?
            <i className={`bi ${icon} fs-4 me-2`}></i> : <div className="me-2">{icon}</div>}{title}</span>
        {showValue != null && <i className={`bi ${showValue ? "bi-chevron-up" : "bi-chevron-down"}`}></i>}
    </Button>
}

function AccountOptions({handleClose, setShowAccount, link = false}) {
    const {loggedIn, admin, userId} = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    function handleOnSelect(path) {
        navigate(path)
        handleClose()
        setShowAccount(false)
    }

    // active={location.pathname.startsWith("/backend")}
    // {active && "fw-semibold"}

    return <div className={`d-flex flex-wrap gap-2 ${link ? "flex-column ms-1 w-100" : "ms-3"}`}>
        {loggedIn && <Button variant={`${link ? "link" : "outline-primary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/profile") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/profile")}>{link &&
            <i className="bi bi-person me-1"/>}Profile</Button>}
        {loggedIn && <Button variant={`${link ? "link" : "outline-primary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/address") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect(`/backend/address/${userId}`)}>{link &&
            <i className="bi bi-geo-alt me-1"/>}Address</Button>}
        {loggedIn && <Button variant={`${link ? "link" : "outline-primary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/order") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect(`/backend/order/${userId}`)}>{link &&
            <i className="bi bi-box me-1"/>}Orders</Button>}

        {admin && <div className="w-100 border-top border-2 my-1"/>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/user") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/user")}>{link &&
            <i className="bi bi-people me-1"/>}Users</Button>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/country") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/country")}>{link &&
            <i className="bi bi-globe me-1"/>}Country</Button>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/carrier") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/carrier")}>{link &&
            <i className="bi bi-truck me-1"/>}Carrier</Button>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/tip") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/tip")}>{link &&
            <i className="bi bi-chat-square-text me-1"/>}Tips</Button>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/tag") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/tag")}>{link &&
            <i className="bi bi-bookmarks me-1"/>}Tags</Button>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/media") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/media")}>{link &&
            <i className="bi bi-file-image me-1"/>}Media</Button>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/product") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/product")}>{link &&
            <i className="bi bi-file-richtext me-1"/>}Product</Button>}
        {admin && <Button variant={`${link ? "link" : "outline-secondary"}`} className={`${link ? "text-decoration-none text-body-emphasis text-start" : ""} 
           ${location.pathname.startsWith("/backend/dispatch") ? "fw-semibold" : ""}`} onClick={() => handleOnSelect("/backend/dispatch")}>{link &&
            <i className="bi bi-send me-1"/>}Dispatch</Button>}
        {admin && link && <div className="w-100 border-bottom border-2 my-1"/>}

        {loggedIn && link && <Button variant={`${link ? "link" : "outline-primary"}`} className={link && "text-decoration-none text-body-emphasis text-start"}
                                     onClick={() => handleOnSelect("/account/logout")}>{link && <i className="bi bi-person-fill-slash me-1"/>}Logout</Button>}

    </div>
}

function NavbarForFullScreen() {
    const navigate = useNavigate()
    const {loggedIn, admin, userId} = useAuth()
    const {darkMode, toggleDarkMode} = useDarkMode()
    const location = useLocation()
    const {count} = useBasketCount()

    const include = local => location.pathname.includes(local)
    const startsWith = path => location.pathname.startsWith(path)

    return <Navbar collapseOnSelect expand="sm" sticky="top" bg="primary" variant="dark" className="p-1">
        <Container fluid="lg">
            {/*<Navbar.Brand href="/"><img src={logo} alt="AltraBits" className=""/></Navbar.Brand>*/}
            <Navbar.Brand href="/"><img src={logoFullW} alt="AltraBits" className=""/></Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav">
                {/*<IconMenu width={26} height={26}/>*/}
            </Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav onSelect={e => navigate(e)}>
                    <Nav.Link eventKey={`/shop`}>Shop</Nav.Link>
                    {loggedIn && <Nav.Link eventKey={`/device/${userId}`}>Control</Nav.Link>}
                </Nav>

                <Nav className="ms-auto" onSelect={e => {
                    if (e === "switchTheme") {
                        navigate(location.pathname + location.search, {state: location.state})
                    } else {
                        navigate(e)
                    }
                }}>

                    {loggedIn && <div className="d-none d-sm-inline"/>}

                    <NavDropdown title={<UserName/>} id={!loggedIn ? "collapsible-nav-account" : ""} drop="down" align="end" className="dropdown-center">
                        <DropMenuItem icon="person-fill-check" label="Login" to="/account/login" publicOnly/>
                        <DropMenuItem icon="person-fill-add" label="Signup" to="/account/signup" publicOnly/>


                        {loggedIn && <NavDropdown.Item active={include("profile")} eventKey="/backend/profile"><IconDropdown
                            name="person"/> Profile</NavDropdown.Item>}
                        {loggedIn && <NavDropdown.Item active={include("address")} eventKey={`/backend/address/${userId}`}><IconDropdown
                            name="geo-alt"/> Address</NavDropdown.Item>}
                        {loggedIn && <NavDropdown.Item active={include("order")} eventKey={`/backend/order/${userId}`}><IconDropdown
                            name="box"/> Orders</NavDropdown.Item>}

                        {admin && <NavDropdown.Divider/>}
                        {admin && <NavDropdown.Item active={include("user")} eventKey="/backend/user"><IconDropdown
                            name="people"/> Users</NavDropdown.Item>}
                        {admin && <NavDropdown.Item active={include("country")} eventKey="/backend/country"><IconDropdown
                            name="globe"/> Country</NavDropdown.Item>}
                        {admin && <NavDropdown.Item active={include("carrier")} eventKey="/backend/carrier"><IconDropdown
                            name="truck"/> Carrier</NavDropdown.Item>}
                        {admin && <NavDropdown.Item active={include("tip")} eventKey="/backend/tip"><IconDropdown
                            name="chat-square-text"/> Tips</NavDropdown.Item>}
                        {admin && <NavDropdown.Item active={include("tags")} eventKey="/backend/tag"><IconDropdown
                            name="bookmarks"/> Tags</NavDropdown.Item>}
                        {admin && <NavDropdown.Item active={include("media")} eventKey="/backend/media"><IconDropdown
                            name="file-image"/> Media</NavDropdown.Item>}
                        {admin && <NavDropdown.Item active={include("product")} eventKey="/backend/product"><IconDropdown
                            name="file-richtext"/> Product</NavDropdown.Item>}
                        {admin && <NavDropdown.Item active={include("dispatch")} eventKey="/backend/dispatch"><IconDropdown
                            name="send"/> Dispatch</NavDropdown.Item>}

                        {loggedIn && <NavDropdown.Divider/>}
                        {loggedIn && <NavDropdown.Item active={include("logout")} eventKey="/account/logout"><IconDropdown
                            name="person-fill-slash"/> Logout</NavDropdown.Item>}
                    </NavDropdown>

                    {/*<div className={`border-start ${loggedIn ? "ms-1" : "ms-2"}`}/>*/}
                    <Nav.Item>
                        <Nav.Link eventKey="/shop/cart" active={startsWith("/shop/cart")}>
                            {<i className={`bi bi-cart${count > 0 ? '-check' : ''} mx-1`} style={{transform: 'scale(1.3)', display: 'inline-block'}}/>}
                        </Nav.Link>
                    </Nav.Item>

                    {/*<div className="border-start m-1"/>*/}
                    <Nav className="" onSelect={toggleDarkMode}>
                        <Nav.Link eventKey="switchTheme">{darkMode ? <i className="bi bi-sun"/> :
                            <i className="bi bi-moon" style={{transform: 'scale(1.2)', display: 'inline-block'}}/>}</Nav.Link>
                    </Nav>

                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>
}

function DropMenuItem({label, icon, to, publicOnly = false, privateOnly = false, adminOnly = false}) {
    const {loggedIn, admin} = useAuth()
    const location = useLocation()

    // const include = local => location.pathname.includes(local)
    const startsWith = path => location.pathname.startsWith(path)

    if ((publicOnly && !loggedIn) || (privateOnly && loggedIn) || (adminOnly && admin)) {
        return <NavDropdown.Item active={startsWith(to)} eventKey={to}>
            <IconDropdown name={icon}/> {label}</NavDropdown.Item>
    }

    return null

}

function UserName() {
    const {loggedIn, user} = useAuth()

    if (loggedIn) {
        return <>
            <i className="bi bi-person fs-2 d-inline d-sm-none"/>
            {(user?.first_name && user?.last_name) && <span className="d-none d-sm-inline">{user.first_name} {user.last_name}</span>}
        </>
    }

    return <i className="bi bi-person fs-3 p-0"/>
}

